import { useState, useEffect, useContext } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { CommonServiceContext } from "../services/common/commonService";
import Loader from "../components/Loader";
import RecaptchaComponent from "../components/RecaptchaComponent";
import { useUserContext } from "../context/user_context";
import OrderTracking from "../components/common/OrderTracking";
import TrackingProgress from "../components/common/TrackingProgress";
import OrderInfo from "../components/common/OrderInfo";
import CompanyLogo from "../components/common/CompanyLogo";
import { IconBrandFacebookFilled, IconSearch } from "@tabler/icons-react";

const Tracking = () => {
  const { id } = useParams();
  const { captchaState, setCaptchaState } = useUserContext();
  const [send, setSend] = useState(false);
  const [resetCaptcha, setResetCaptcha] = useState(false);
  const [notFound, setNotFound] = useState(false);
  const [trackingNumber, setTrackingNumber] = useState(null);
  const navigate = useNavigate();

  const { trackOrder, order, loading, clearOrder } =
    useContext(CommonServiceContext);

  useEffect(() => {
    setCaptchaState({ ask: true, token: captchaState.token });
  }, []);

  useEffect(() => {
    //fetchOrder();
    if (captchaState.token && !resetCaptcha) {
      fetchOrder();
    }
  }, [captchaState]);

  const handleChange = (e) => {
    setTrackingNumber(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    if (!trackingNumber) return;

    e.preventDefault();

    navigate(`/tracking/${trackingNumber}`);
    window.location.reload();
  };
  //9770885
  const fetchOrder = async () => {
    if (!id) return;
    const postData = {
      recaptchaCode: captchaState.token,
      trackingNumbers: [id.toString()],
    };
    //window.grecaptcha.reset();

    const response = await trackOrder(postData);
    setResetCaptcha(!resetCaptcha);
    setCaptchaState({ ask: false, token: null });
    setSend(false);
    console.log(response);
  };

  return (
    <>
      {loading && <Loader />}

      <div className="flex gap-15 w-full relative z-[1] justify-end mb-10">
        <div className="w-1/5">
          <div className="card bg-card-color rounded-xl p-4 relative border border-dashed border-border-color">
            <form onSubmit={handleSearchSubmit}>
              <label className="form-label mb-5 inline-block">
                შეიყვანეთ გზავნილის ნომერი
              </label>
              <div className="form-control flex w-full">
                <input
                  type="text"
                  id="team_board_search"
                  className="form-input !rounded-e-none !py-[6px]"
                  placeholder="Search..."
                  onChange={(e) => handleChange(e)}
                />
                <button
                  className="btn border border-border-color !rounded-s-none"
                  type={"submit"}
                >
                  <IconSearch className="w-[20px] h-[20px]" />
                  ძიება
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div className="flex gap-15 w-full relative z-[1]">
        <div className="items-center justify-center w-1/3 md:flex hidden">
          <div className="max-w-[400px]">
            <Link to="/">
              <div className="mb-4">
                <CompanyLogo className="text-primary w-[256px] h-auto" />
              </div>
            </Link>
            <p className="mb-12 text-[32px]/[40px] font-medium">
              საფოსტო საკურიერო სერვისი
            </p>
            <div className="mb-8">
              <p className="text-[24px]/[30px] mb-2">
                საფოსტო საკურიერო სერვისი საქართველოს მასშტაბით.
              </p>
              <p>ქსპრეს მიწოდება საქართველოს ყველა რეგიონში</p>
            </div>
            {/* <div className="mb-12">
                  <p className="text-[24px]/[30px] mb-2">
                    Easily add & manage your services
                  </p>
                  <p>
                    It brings together your tasks, projects, timelines, files
                    and more
                  </p>
                </div> */}
            <div className="flex flex-wrap gap-4 mb-4">
              <Link to="/" className="transition-all hover:text-primary">
                მთავარი
              </Link>
              <Link to="/contact" className="transition-all hover:text-primary">
                კონტაქტი
              </Link>
              <Link to="/faq" className="transition-all hover:text-primary">
                FAQs
              </Link>
            </div>
            <div className="flex flex-wrap gap-4">
              <Link
                to="https://www.facebook.com/Geoexpress.ge/"
                target="_blank"
                className="w-[34px] h-[34px] rounded-full bg-border-color flex items-center justify-center text-white transition-all hover:bg-secondary"
              >
                <IconBrandFacebookFilled width="18" height="18" />
              </Link>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-center w-full">
          <div className="bg-card-color rounded-xl sm:p-4 p-2 max-w-[90vw] w-full shadow-shadow-sm border border-dashed border-border-color">
            <div className="sm:max-h-[calc(100svh-48px-32px)] max-h-[calc(100svh-48px-16px)] sm:p-4 p-3 overflow-auto custom-scrollbar">
              {captchaState.ask ? (
                <>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <div
                      id="captcha"
                      style={{
                        display: captchaState.ask ? "block" : "none",
                      }}
                    >
                      <RecaptchaComponent reset={resetCaptcha} />
                    </div>
                  </div>
                </>
              ) : (
                <>
                  {order?.code == -1 ? (
                    "გზავნილი ვერ მოიძებნა"
                  ) : (
                    <>
                      <TrackingProgress progress={order?.progressPercent} />
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <OrderTracking orderData={order?.checkPoints} />
                        <OrderInfo data={order} />
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
//9770885
//9780005
export default Tracking;
